import { useState } from 'react';
import { resolveImageUrl } from '@/lib/utils';

export default function PropertyGallery({ images }: { images: string[] }) {
  const [open, setOpen] = useState<number | null>(null);

  if (!images || images.length === 0) {
    return (
      <div className="aspect-video w-full rounded-xl bg-muted flex items-center justify-center text-sm text-muted-foreground">
        Sin fotos
      </div>
    );
  }

  const close = () => setOpen(null);
  const prev = () => setOpen((i) => (i === null ? i : (i - 1 + images.length) % images.length));
  const next = () => setOpen((i) => (i === null ? i : (i + 1) % images.length));

  return (
    <>
      <div className="grid grid-cols-3 gap-2">
        {images.map((url, idx) => (
          <button
            key={idx}
            type="button"
            aria-label={`Ver foto ${idx + 1}`}
            onClick={() => setOpen(idx)}
            className="aspect-video rounded-lg overflow-hidden border border-border bg-muted"
          >
            <img src={resolveImageUrl(url)} alt={`Foto ${idx + 1}`} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
      {open !== null && (
        <div
          role="dialog"
          aria-label="Galería de fotos"
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4"
          onClick={close}
        >
          <button type="button" aria-label="Cerrar" onClick={close} className="absolute top-4 right-4 text-white text-2xl">×</button>
          <button type="button" aria-label="Anterior" onClick={(e) => { e.stopPropagation(); prev(); }} className="absolute left-4 text-white text-3xl">‹</button>
          <img
            src={resolveImageUrl(images[open])}
            alt={`Foto ${open + 1}`}
            className="max-h-[85vh] max-w-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <button type="button" aria-label="Siguiente" onClick={(e) => { e.stopPropagation(); next(); }} className="absolute right-4 text-white text-3xl">›</button>
        </div>
      )}
    </>
  );
}
